import React, { useContext } from "react";
import styled from "styled-components";
import Section from "../Section";
import Icons from "../Icons";
import { useMutation, gql } from "@apollo/client";
import { ProfileContext } from "../../reducers/profile";
import { useHistory } from "react-router";
import { NavLink } from "react-router-dom";

const HeaderSection = styled(Section)`
  display: flex;
  padding: 10px 0;
  position: relative;

  div {
    position: absolute;
    right: 0;
    align-self: center;
  }

  svg {
    fill: #ffffff;
    height: 50px;

    :first-child {
      margin-right: 35px;
    }
  }
`;

const Header = styled.header`
  background: #2075bc;
  height: 70px;
`;

const HeaderButton = styled.button`
  background-color: initial;
  border: none;
  text-decoration: none;

  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;

  margin-left: 10px;
  :not(:first-child) {
  }
`;

const SIGN_OF = gql`
  mutation ($id: ID!) {
    signOf(id: $id)
  }
`;

export default () => {
  const [signOf] = useMutation(SIGN_OF);
  const history = useHistory();
  const {
    state: { is_auth, user_id, is_admin },
    dispatch,
  } = useContext(ProfileContext);

  const onExit = () => {
    signOf({ variables: { id: user_id } }).catch((error) =>
      console.error(error),
    );

    dispatch({ type: "ME_RESET" });
    history.push("/");
  };

  return (
    <Header>
      <HeaderSection as="div">
        <Icons icon="logoDepMos" width={139.29} />
        <Icons icon="logoBiblio" width={133.33} />
        <div>
          {is_admin && (
            <HeaderButton
              as={NavLink}
              to="/juries"
              activeStyle={{
                fontSize: "22px",
              }}
            >
              Жюри
            </HeaderButton>
          )}
          {is_admin && (
            <HeaderButton
              as={NavLink}
              to="/results"
              activeStyle={{
                fontSize: "22px",
              }}
            >
              Рейтинг
            </HeaderButton>
          )}
          {is_auth && <HeaderButton onClick={onExit}>Выход</HeaderButton>}
        </div>
      </HeaderSection>
    </Header>
  );
};
